import { ApiBase } from '@bymason/api-base';
import { CmsProductCarouselWidget } from './types';
import tempData from './temp-data';

export * from './types';

class ProductCarouselWidgetCmsApi extends ApiBase {
  private static instance: ProductCarouselWidgetCmsApi;

  private constructor() {
    super();
  }

  /**
   * There is no need for consumers to ever call this method as its purely used to enforce a singleton module pattern.
   * @returns A ProductCarouselWidgetCmsApi instance
   */
  public static getInstance(): ProductCarouselWidgetCmsApi {
    if (!ProductCarouselWidgetCmsApi.instance) {
      ProductCarouselWidgetCmsApi.instance = new ProductCarouselWidgetCmsApi();
    }

    return ProductCarouselWidgetCmsApi.instance;
  }

  /**
   * Gets the CMS content for the product carousel widget.
   * @returns either a CmsProductCarousel model or void
   */
  public async getProductCarouselContent(_clientToken?: string) {
    //
    // TODOs:
    // 1. Call metadata API to get list of current device types and if clientToken provided, a list of legacy device types
    // 2. Setup endpoint calls to get content from Strapi CMS for respective device types
    //
    const dataResponse = await Promise.resolve<CmsProductCarouselWidget>(tempData);

    return dataResponse;
  }
}

export const productCarouselWidgetCmsApi = ProductCarouselWidgetCmsApi.getInstance();
